import moment from 'moment';

import { IUser } from 'src/app/_shared/classes/user';
import { IAccount } from 'src/app/_shared/classes/account';
import { Hierarchy } from 'src/app/_shared/interface/hierarchy.interface';
import { SubscriptionUrlData } from 'src/app/_shared/interface/subscription-data.interface';

export function buildShopifySubscriptionLink(
  user: IUser,
  userAccount: IAccount,
  hierarchy: Hierarchy
): SubscriptionUrlData {
  const legacyCustomer = moment(userAccount.creationDate, 'YYYY-MM-DDTHH:mm:SSSZ').isBefore('2025-12-15T00:00:00Z');

  let link = 'https://powerside-store.myshopify.com/cart';

  if (legacyCustomer) {
    link += '/46979340828925:';
  } else {
    link += '/46746302841085:';
  }
  link += getMeasurementPointCount(hierarchy).toString() + '?';

  if (user.email) {
    link += `checkout[email]=${encodeURIComponent(user.email)}&`;
  }
  if (userAccount.name) {
    link += `attributes[company_name]=${encodeURIComponent(userAccount.name)}&`;
  }

  link += 'note=Qubescan-Order&storefront=true';

  return {
    subscriptionLink: link,
    isLegacyCustomer: legacyCustomer,
  };
}

function getMeasurementPointCount(hierarchy: Hierarchy): number {
  let mpCount = 0;

  hierarchy.partners.forEach((partner) => {
    partner.customers.forEach((customer) => {
      if (!customer.isDemoAccount) {
        mpCount += customer.measurementPoints.length;
      }
    });
  });
  return mpCount;
}
